import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { AdminSidenavComponent } from './admin-sidenav/admin-sidenav.component';
import { MaterialModule } from '../Core/material.module';
import { AdminFooterComponent } from './admin-footer/admin-footer.component';



@NgModule({
  declarations: [AdminLayoutComponent, LoginLayoutComponent, AdminHeaderComponent, AdminSidenavComponent, AdminFooterComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    // FlexLayoutModule,
    MaterialModule
  ],
  exports: [AdminLayoutComponent, LoginLayoutComponent, AdminHeaderComponent, AdminSidenavComponent, AdminFooterComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class LayoutModule { }
